export class SsoRequestParameter {

    public parameterName: string;
    public parameterValue: string;

    constructor(
        parameterName: string,
        parameterValue: string
    ) {
        this.parameterName = parameterName;
        this.parameterValue = parameterValue;
    }
}